/* Atelier Earthmade — quiet scroll reveals. Sections rise once as they enter.
   Film bands are excluded from the transform (a transformed ancestor would
   break their position:sticky hold) and instead receive the .in class their
   captions already listen for. Sections already scrolled past (deep links,
   restored scroll positions) are revealed immediately — nothing may ever be
   left invisible. Honors prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    if (reduce.matches || !('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll(
      'main[data-template="index"] .shopify-section:not(:first-child):not(:has(.em-film)):not(:has(.em-hero))'
    );
    var films = document.querySelectorAll('.em-film');
    var reveal = function (el) {
      if (el.classList.contains('em-film')) el.classList.add('in');
      else el.classList.add('em-in');
    };
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var passed = e.rootBounds && e.boundingClientRect.bottom < e.rootBounds.top;
          if (!e.isIntersecting && !passed) return;
          reveal(e.target);
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    sections.forEach(function (el) {
      el.classList.add('em-observe');
      io.observe(el);
    });
    films.forEach(function (el) {
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
